import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants';

const GEO_LOCATION_API = 'https://ipapi.co/json/';

type GeoLocationData = {
  country?: string;
  city?: string;
  region?: string;
};

const fetchGeoLocation = async (): Promise<GeoLocationData | null> => {
  try {
    const response = await fetch(GEO_LOCATION_API);
    if (!response.ok) return null;

    const data = await response.json();

    return {
      city: data.city,
      region: data.region,
      country: data.country_code,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to fetch geo location:', error);
    return null;
  }
};

export const useGeoLocation = (enabled = true) => {
  return useQuery({
    queryKey: [QUERY_KEYS.geoLocation],
    queryFn: fetchGeoLocation,
    enabled,
    staleTime: Infinity,
  });
};
